export const iconFontAwesomeUsersPeoplePersonRays = (
	<i className="fa-solid fa-person-rays"></i>
);
